import React from "react";
import AuthExperience from "../experience/AuthExperience";
import { beginIdentityRegistration } from "../identity/identityClient";

export default function Register() {
  return (
    <AuthExperience
      onContinue={beginIdentityRegistration}
      mode="signup"
      productName="My Clikkle"
      productHomeUrl="https://clikkle.com"
      productBrandPath="/images/clikkle/brand/logos/myaccount-logo.png"
    />
  );
}
